/* custom-filter-grid.js — AlbumMags client-side filter (index schema v1, see build_index.py)
   URL params (also used by homepage tiles; multiple values '|' or ',' separated):
     types=album|movie|tv|other   decades=1950s..2020s|other   genres=Horror|Rock…   formats=Standard|Mini|Magazine Cover
     artists=<name>  directors=<name>  cast=<name>  q=<text>  sort=new|best|title|year  page=N
   Aliases: type=, decade=, movies, tv-shows, 90s, 1990, more-classics */
(() => {
  const TYPES = ['album', 'movie', 'tv', 'other'];
  const TYPE_LABEL = { album: 'Albums', movie: 'Movies', tv: 'TV Shows', other: 'Other' };
  const ROW = { h: 0, t: 1, img: 2, p: 3, d: 4, ty: 5, y: 6, a: 7, g: 8, ca: 9, dec: 10, r: 11, cb: 12, dir: 13, cast: 14, fmt: 15 };
  const TYPE_ALIAS = { albums: 'album', 'album-magnets': 'album', movies: 'movie', 'movie-magnets': 'movie', tvshow: 'tv', 'tv-show': 'tv', 'tv-shows': 'tv', tvshows: 'tv', 'tv-show-magnets': 'tv' };
  const TYPE_COLL = { 'album-magnets': 'album', 'movie-magnets': 'movie', 'tv-show-magnets': 'tv' };
  const DECADE_COLL = { '1950': '1950s', '1950s': '1950s', '1960s': '1960s', '1970s': '1970s', '1980s': '1980s', '1990s': '1990s', '2000s': '2000s', '2010': '2010s', '2010s': '2010s', '2020': '2020s', '2020s': '2020s' };
  const MULTI = ['types', 'decades', 'genres', 'formats', 'artists', 'directors', 'cast'];
  const normType = (v) => { v = String(v).toLowerCase().trim(); return TYPE_ALIAS[v] || v; };
  const normDecade = (v) => {
    v = String(v).trim();
    if (/^(other|more[- ]?classics)$/i.test(v)) return 'other';
    const m = v.match(/^(\d{2}|\d{4})s?$/); if (!m) return v;
    let y = +m[1]; if (y < 100) y += y < 30 ? 2000 : 1900; return Math.floor(y / 10) * 10 + 's';
  };
  const esc = (s) => String(s).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
  const norm = (s) => String(s).toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '');
  const arr = (v) => (Array.isArray(v) ? v : v === 0 || v == null || v === -1 ? [] : [v]);

  async function init(root) {
    const $ = (s) => root.querySelector(s);
    const base = (root.dataset.indexBase || '').trim();
    const coll = root.dataset.collection || '';
    const homeType = root.dataset.type || TYPE_COLL[coll] || '';           // auto-checked, but shoppers may add others
    const lockDecade = root.dataset.decade || DECADE_COLL[coll] || '';
    const defSort = root.dataset.defaultSort || (coll === 'newest-additions' ? 'new' : 'best');
    const size = +root.dataset.pageSize || 36;
    const cur = root.dataset.currency || '$';
    const otherLabel = root.dataset.otherDecadeLabel || 'More Classics';
    const url = base ? base.replace(/\/?$/, '/') + 'albummags-index-all.json' : root.dataset.urlAll;  // combined index so types can be mixed
    let idx;
    try { idx = await (await fetch(url, { cache: 'default' })).json(); } catch (e) { $('.cfg__count').textContent = 'Could not load products. Please refresh.'; return; }

    // restrict to collection members when the index knows them (decades, best-sellers); type collections are a default
    // type check instead; all / newest-additions / unknown collections show the full catalog
    const collBit = !homeType && idx.colls ? idx.colls.indexOf(coll) : -1;
    const rows = collBit >= 0 ? idx.rows.filter((r) => (r[ROW.cb] >> collBit) & 1) : idx.rows;
    const ppl = idx.people || [], genres = idx.genres || [], formats = idx.formats || [];
    const keys = rows.map((r) => norm([r[ROW.t], r[ROW.a] >= 0 ? idx.artists[r[ROW.a]] : '', ...arr(r[ROW.dir]).map((i) => ppl[i]), ...arr(r[ROW.cast]).map((i) => ppl[i])].join(' ')));
    const decOf = (r) => (r[ROW.dec] ? r[ROW.dec] + 's' : 'other');
    const V = {   // facet -> values of a row (array)
      types: (r) => [TYPES[r[ROW.ty]]],
      decades: (r) => [decOf(r)],
      genres: (r) => arr(r[ROW.g]).map((i) => genres[i]),
      formats: (r) => (formats.length && r[ROW.fmt] != null ? [formats[r[ROW.fmt]]] : []),
      artists: (r) => (r[ROW.a] >= 0 ? [idx.artists[r[ROW.a]]] : []),
      directors: (r) => arr(r[ROW.dir]).map((i) => ppl[i]),
      cast: (r) => arr(r[ROW.cast]).map((i) => ppl[i]),
    };
    const defaults = () => ({ types: new Set(homeType ? [homeType] : []) });

    const st = { q: '', sort: defSort, pmin: '', pmax: '', page: 1 };
    MULTI.forEach((k) => (st[k] = new Set()));
    const readURL = () => {
      const u = new URLSearchParams(location.search);
      st.q = u.get('q') || ''; st.sort = u.get('sort') || defSort;
      MULTI.forEach((k) => (st[k] = new Set((u.get(k) || '').split(['types', 'decades'].includes(k) ? /[|,]/ : '|').map((v) => v.trim()).filter(Boolean))));
      if (u.get('type')) u.get('type').split(/[|,]/).filter((v) => !['product', 'article', 'page'].includes(v.trim())).forEach((v) => st.types.add(v));
      if (u.get('decade')) u.get('decade').split(/[|,]/).forEach((v) => st.decades.add(v));
      st.types = new Set([...st.types].map(normType)); st.decades = new Set([...st.decades].map(normDecade));
      if (!u.has('types') && !u.has('type')) st.types = defaults().types;
      if (lockDecade) st.decades.clear();
      st.pmin = u.get('pmin') || ''; st.pmax = u.get('pmax') || ''; st.page = +u.get('page') || 1;
    };
    const writeURL = () => {
      const u = new URLSearchParams(location.search);
      const set = (k, v) => (v ? u.set(k, v) : u.delete(k));
      u.delete('type'); u.delete('decade');
      set('q', st.q); set('sort', st.sort === defSort ? '' : st.sort);
      MULTI.forEach((k) => set(k, [...st[k]].join('|')));
      const dt = [...defaults().types].join('|');
      if ([...st.types].join('|') === dt) u.delete('types'); else if (!st.types.size && dt) u.set('types', '');
      set('pmin', st.pmin); set('pmax', st.pmax); set('page', st.page > 1 ? st.page : '');
      const qs = u.toString();
      history.replaceState(null, '', location.pathname + (qs ? '?' + qs.replace(/=$|=&/g, (m) => m) : ''));
    };

    const has = (k, r) => !st[k].size || V[k](r).some((v) => st[k].has(v));
    const pass = (i, skip) => {
      const r = rows[i];
      if (lockDecade && collBit < 0 && decOf(r) !== lockDecade) return false;
      for (const k of MULTI) if (k !== skip && !has(k, r)) return false;
      const p = r[ROW.p] / 100;
      if (st.pmin !== '' && p < +st.pmin) return false;
      if (st.pmax !== '' && p > +st.pmax) return false;
      if (st.q) { const k = keys[i]; for (const w of norm(st.q).split(/\s+/)) if (w && !k.includes(w)) return false; }
      return true;
    };

    // facet UI: el = container; returns number of values with data
    const facet = (key, el, { label = (v) => v, order, limit, filterText, seed } = {}) => {
      const counts = new Map((seed || []).map((v) => [v, 0]));
      let any = 0;
      for (let i = 0; i < rows.length; i++) {
        const vs = V[key](rows[i]); if (vs.length) any++;
        if (vs.length && pass(i, key)) for (const v of vs) if (v) counts.set(v, (counts.get(v) || 0) + 1);
      }
      st[key].forEach((v) => counts.has(v) || counts.set(v, 0));
      let list = [...counts.entries()];
      if (filterText) list = list.filter(([v]) => norm(v).includes(norm(filterText)) || st[key].has(v));
      list.sort(order || ((a, b) => b[1] - a[1] || a[0].localeCompare(b[0])));
      if (limit) list = list.slice(0, limit);
      el.innerHTML = list.map(([v, n]) =>
        `<label class="cfg__opt"><input type="checkbox" data-k="${key}" value="${esc(v)}"${st[key].has(v) ? ' checked' : ''}> ${esc(label(v))} <small>${n.toLocaleString()}</small></label>`).join('') || '<small>No matches</small>';
      return any || st[key].size || (seed ? 1 : 0);
    };
    const show = (sel, on) => { const el = $(sel); if (el) el.hidden = !on; };
    const q = (sel) => ($(sel) ? $(sel).value : '');

    const card = (r) => {
      const href = `/products/${r[ROW.h]}`;
      const img = r[ROW.img] ? (r[ROW.img].startsWith('http') ? r[ROW.img] : idx.img_base + r[ROW.img]) : '';
      const src = (w) => img + (img.includes('?') ? '&' : '?') + 'width=' + w;
      const price = cur + (r[ROW.p] / 100).toFixed(2);
      const sale = r[ROW.ca] > r[ROW.p];
      return `<li class="grid__item"><div class="card-wrapper product-card-wrapper underline-links-hover">
        <div class="card card--standard card--media" style="--ratio-percent:100%;"><div class="card__inner color-scheme-1 gradient ratio" style="--ratio-percent:100%;">
        ${img ? `<div class="card__media"><div class="media media--transparent media--hover-effect"><img src="${src(360)}" srcset="${src(180)} 180w, ${src(360)} 360w, ${src(533)} 533w" sizes="(min-width:990px) 25vw, 50vw" alt="${esc(r[ROW.t])}" loading="lazy" width="360" height="360" class="motion-reduce"></div></div>` : ''}
        ${sale ? '<div class="card__badge bottom left"><span class="badge badge--bottom-left color-scheme-4">Sale</span></div>' : ''}
        </div><div class="card__content"><div class="card__information">
        <h3 class="card__heading h5"><a href="${href}" class="full-unstyled-link">${esc(r[ROW.t])}</a></h3>
        <div class="card-information"><div class="price${sale ? ' price--on-sale' : ''}"><div class="price__container">
        ${sale ? `<span class="price-item price-item--sale price-item--last">${price}</span> <s class="price-item price-item--regular">${cur}${(r[ROW.ca] / 100).toFixed(2)}</s>` : `<span class="price-item price-item--regular">${price}</span>`}
        </div></div></div></div></div></div></div></li>`;
    };

    const sorters = {
      new: (a, b) => b[ROW.d] - a[ROW.d],
      best: (a, b) => (a[ROW.r] || 1e9) - (b[ROW.r] || 1e9) || b[ROW.d] - a[ROW.d],
      title: (a, b) => a[ROW.t].localeCompare(b[ROW.t]),
      year: (a, b) => (a[ROW.y] || 9999) - (b[ROW.y] || 9999),
    };

    const render = (scroll) => {
      const hits = [];
      for (let i = 0; i < rows.length; i++) if (pass(i)) hits.push(rows[i]);
      hits.sort(sorters[st.sort] || sorters.best);
      const pages = Math.max(1, Math.ceil(hits.length / size));
      st.page = Math.min(st.page, pages);
      $('.cfg__grid').innerHTML = hits.slice((st.page - 1) * size, st.page * size).map(card).join('');
      $('.cfg__count').textContent = `${hits.length.toLocaleString()} product${hits.length === 1 ? '' : 's'}`;
      const btn = (p, label, dis, curr) => `<button type="button" data-page="${p}"${dis ? ' disabled' : ''}${curr ? ' aria-current="page"' : ''}>${label}</button>`;
      let h = btn(st.page - 1, '‹', st.page === 1), last = 0;
      for (const p of [...new Set([1, pages, st.page - 2, st.page - 1, st.page, st.page + 1, st.page + 2])].filter((p) => p >= 1 && p <= pages).sort((a, b) => a - b)) {
        if (p - last > 1) h += '<span>…</span>';
        h += btn(p, p, false, p === st.page); last = p;
      }
      $('.cfg__pager').innerHTML = pages > 1 ? h + btn(st.page + 1, '›', st.page === pages) : '';

      facet('types', $('.cfg__types-list'), { label: (v) => TYPE_LABEL[v] || v, order: (a, b) => TYPES.indexOf(a[0]) - TYPES.indexOf(b[0]), seed: TYPES });
      if (!lockDecade) facet('decades', $('.cfg__decades-list'), { label: (v) => (v === 'other' ? otherLabel : v), order: (a, b) => (a[0] === 'other') - (b[0] === 'other') || a[0].localeCompare(b[0]) });
      show('.cfg__decades', !lockDecade);
      show('.cfg__genres-wrap', genres.length && facet('genres', $('.cfg__genres'), { order: (a, b) => b[1] - a[1] || a[0].localeCompare(b[0]) }));
      show('.cfg__formats-wrap', formats.length && facet('formats', $('.cfg__formats'), { order: (a, b) => formats.indexOf(a[0]) - formats.indexOf(b[0]) }));
      show('.cfg__artists-wrap', facet('artists', $('.cfg__artists-list'), { limit: 200, filterText: q('.cfg__artist-q') }));
      show('.cfg__directors-wrap', ppl.length && facet('directors', $('.cfg__directors'), { limit: 200, filterText: q('.cfg__director-q') }));
      show('.cfg__cast-wrap', ppl.length && facet('cast', $('.cfg__cast'), { limit: 200, filterText: q('.cfg__cast-q') }));
      writeURL();
      if (scroll) root.scrollIntoView({ behavior: 'smooth', block: 'start' });
    };

    readURL();
    $('.cfg__q').value = st.q; $('.cfg__sort').value = st.sort; if ($('.cfg__pmin')) { $('.cfg__pmin').value = st.pmin; $('.cfg__pmax').value = st.pmax; }
    let t;
    const debounced = (fn) => { clearTimeout(t); t = setTimeout(fn, 200); };
    $('.cfg__q').addEventListener('input', (e) => debounced(() => { st.q = e.target.value.trim(); st.page = 1; render(); }));
    root.querySelectorAll('.cfg__artist-q,.cfg__director-q,.cfg__cast-q').forEach((el) => el.addEventListener('input', () => debounced(() => render())));
    $('.cfg__sort').addEventListener('change', (e) => { st.sort = e.target.value; st.page = 1; render(); });
    root.querySelectorAll('.cfg__pmin,.cfg__pmax').forEach((el) => el.addEventListener('input', () => debounced(() => { st.pmin = $('.cfg__pmin').value; st.pmax = $('.cfg__pmax').value; st.page = 1; render(); })));
    root.addEventListener('change', (e) => {
      const k = e.target.dataset && e.target.dataset.k; if (!k) return;
      e.target.checked ? st[k].add(e.target.value) : st[k].delete(e.target.value); st.page = 1; render();
    });
    root.addEventListener('click', (e) => { const p = e.target.closest('[data-page]'); if (p && !p.disabled) { st.page = +p.dataset.page; render(true); } });
    $('.cfg__clear').addEventListener('click', () => {
      Object.assign(st, { q: '', pmin: '', pmax: '', page: 1 }); MULTI.forEach((k) => st[k].clear()); st.types = defaults().types;
      root.querySelectorAll('.cfg__side input[type=search],.cfg__side input[type=number]').forEach((el) => (el.value = '')); render();
    });
    $('.cfg__toggle').addEventListener('click', (e) => { const o = root.classList.toggle('is-open'); e.target.setAttribute('aria-expanded', o); });
    render();
  }
  const start = () => document.querySelectorAll('.cfg').forEach(init);
  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', start) : start();
})();